// FAQ.jsx — sección "Preguntas frecuentes", expandida en categorías (fallback si la API no responde).

import React from 'react'

function FAQItem({ q, a, open, onClick }) {
  return (
    <div
      style={{
        borderBottom: "1px solid var(--line)",
        padding: "20px 0",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 24 }}>
        <h3 style={{ fontFamily: "var(--display)", fontSize: 22, margin: 0, textTransform: "uppercase", letterSpacing: 0, lineHeight: 1.15, color: open ? "var(--gold)" : "var(--fg)" }}>
          {q}
        </h3>
        <span
          style={{
            width: 28, height: 28, borderRadius: "50%",
            border: "1px solid var(--line-2)",
            display: "grid", placeItems: "center",
            flexShrink: 0,
            color: open ? "var(--gold)" : "var(--fg-mute)",
            transform: open ? "rotate(45deg)" : "rotate(0)",
            transition: "transform .2s, color .2s",
          }}
        >
          <svg width="12" height="12" viewBox="0 0 12 12">
            <line x1="6" y1="2" x2="6" y2="10" stroke="currentColor" strokeWidth="1.5" />
            <line x1="2" y1="6" x2="10" y2="6" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        </span>
      </div>
      {open && (
        <div
          style={{
            marginTop: 12, fontSize: 14.5, color: "var(--fg-mute)", lineHeight: 1.6,
            maxWidth: "70ch", animation: "fadeUp .3s ease both"
          }}
        >
          {a}
        </div>
      )}
    </div>
  );
}

const FAQ_DATA_FALLBACK = [
  {
    cat: "El proyecto",
    items: [
      ["¿Qué es la campaña #MecanicaParaQuilpue?",
        "Es una campaña de recaudación del Cuerpo de Bomberos de Quilpué para adquirir un carro de escala mecánica — el vehículo que permite a los bomberos llegar a los pisos altos de un edificio en una emergencia."],
      ["¿Por qué Quilpué necesita una escala mecánica?",
        "Quilpué y Villa Alemana son las únicas ciudades importantes de la Provincia de Marga Marga que no cuentan con este equipo. Valparaíso, Viña del Mar y Limache ya tienen. Marga Marga lleva más de una década sin cobertura aérea propia en emergencias."],
      ["¿Qué tan urgente es esto?",
        "Quilpué concentra cerca de 55 torres residenciales de 10 a 18 pisos en su zona céntrica, otras 40 edificaciones de 8 a 12 pisos en Valencia y Paso Hondo, y más de 200 blocks en El Belloto. Sin escala mecánica, ante un incendio en altura los bomberos deben esperar el apoyo de unidades de otras comunas."],
      ["¿A quién protege la escala mecánica?",
        "A toda la Provincia de Marga Marga — Quilpué, Villa Alemana y comunas vecinas. Son más de 294.000 personas que hoy no cuentan con cobertura aérea local."],
      ["¿Cuáles son los términos y condiciones?",
        "Este portal es operado por el Cuerpo de Bomberos de Quilpué, persona jurídica de derecho privado con personalidad jurídica vigente, con el único fin de recaudar fondos para la adquisición de un carro de escala mecánica destinado a la Segunda Compañía. Al donar declaras que los fondos provienen de fuentes lícitas y que aceptas la operatoria de la plataforma. Los aportes son irrevocables y se destinan íntegramente al proyecto; si por alguna razón el proyecto se reasigna, los fondos permanecerán dentro del patrimonio del Cuerpo de Bomberos de Quilpué. El uso del sitio implica la aceptación de estos términos. Los contenidos, marcas, logotipos y piezas gráficas son de propiedad de sus respectivos titulares y están protegidos por la legislación chilena de propiedad intelectual."],
    ],
  },
  {
    cat: "El equipo a adquirir",
    items: [
      ["¿Qué tipo de carro van a comprar?",
        "Un carro de escala mecánica certificado bajo norma NFPA 1901, configuración Quint: combina bomba, estanque, escala telescópica de hasta 32 m con monitor elevado, y banco de escalas manuales. Puede alcanzar entre 10 y 11 pisos."],
      ["¿Cuánto cuesta?",
        "Entre $600.000.000 y $800.000.000 CLP dependiendo del modelo, equipamiento y condiciones de importación. La meta de la campaña se fijó en $800.000.000 para cubrir el costo total incluyendo importación, equipamiento complementario y capacitación de la dotación."],
      ["¿Ya tienen el carro elegido?",
        "El proyecto institucional contempla varias alternativas evaluadas técnicamente bajo norma NFPA 1901. La decisión final del modelo se tomará una vez asegurado el financiamiento y según la evaluación final del equipo técnico del Cuerpo de Bomberos."],
      ["¿Cuándo llegaría el carro a Quilpué?",
        "Según el cronograma del proyecto, si la meta se alcanza en octubre 2026, el carro estaría operativo en el cuartel de la Segunda Compañía hacia fines de 2026 o comienzos de 2027."],
    ],
  },
  {
    cat: "Las donaciones",
    items: [
      ["¿Cómo puedo donar?",
        "Directamente en este portal con tarjeta de débito, crédito, prepago, Mercado Pago o transferencia bancaria. La donación mínima es de $1.000 pesos."],
      ["¿Cuál es la donación mínima?",
        "$1.000 pesos. No hay tope máximo."],
      ["¿Puedo donar de forma anónima?",
        "Sí. Al momento de donar puedes elegir aparecer como ‘Anónimo’ o ‘Un quilpueíno’ en el feed de donaciones. Tu identidad nunca se hace pública sin tu consentimiento explícito."],
      ["¿Cómo sé que mi donación llegó?",
        "Recibirás un correo de confirmación inmediato con el monto, la fecha y el avance actual de la meta. Tu aporte también aparece en tiempo real en el feed del portal."],
      ["¿Puedo donar como empresa?",
        "Sí. Las donaciones de empresas tienen beneficio tributario bajo la Ley N° 21.440. Recibes el certificado de donación para el SII en las 24 horas siguientes a la transferencia."],
      ["¿Qué pasa si no se alcanza la meta?",
        "Los fondos se acumulan en una cuenta corriente exclusiva para este proyecto. No hay fecha de vencimiento: el objetivo es adquirir el carro, y la campaña continúa hasta lograrlo."],
      ["¿Cómo sé que el dinero se usa correctamente?",
        "El portal muestra en tiempo real el total recaudado y cada aporte. La cuenta corriente es exclusiva para este proyecto y se rinde ante el Directorio del Cuerpo de Bomberos de Quilpué y la Junta Nacional de Bomberos de Chile."],
    ],
  },
  {
    cat: "Medios de pago",
    items: [
      ["¿Con qué medios de pago puedo donar?",
        "Aceptamos tarjeta de débito RedCompra, tarjeta de crédito (Visa, Mastercard, American Express), tarjeta prepago (MACH, FAN, Cuenta RUT BancoEstado), Mercado Pago y transferencia bancaria directa."],
      ["¿Es seguro pagar con tarjeta en este portal?",
        "Sí. Los pagos se procesan a través de MercadoPago. El portal nunca almacena datos de tu tarjeta. Toda la transacción ocurre en un entorno encriptado bajo HTTPS con certificado SSL premium."],
      ["¿Puedo donar por transferencia bancaria?",
        "Sí. Transfiere a la cuenta exclusiva de la campaña y envía el comprobante a donaciones@bomberosquilpue.cl con el asunto ‘Donación [tu nombre]’. Recibirás la confirmación en máximo 24 horas hábiles."],
      ["¿Puedo donar desde el extranjero?",
        "Sí, con tarjeta de crédito internacional o por transferencia. Si el monto supera USD $10.000, se aplican requisitos adicionales de reporte al SII."],
      ["¿Hay comisión por donar?",
        "No. El 100% de tu aporte va al proyecto. Las comisiones de la pasarela de pago son absorbidas por la campaña."],
      ["¿Qué pasa si mi pago falla?",
        "Si el pago no se procesa, no se realiza ningún cargo. Puedes intentarlo nuevamente o contactarnos a donaciones@bomberosquilpue.cl."],
      ["¿Cuánto demora en verse mi donación en el portal?",
        "Pagos con tarjeta y Mercado Pago aparecen en el feed en tiempo real — menos de 1 minuto. Transferencias bancarias aparecen dentro de las 24 horas hábiles siguientes a su acreditación."],
    ],
  },
  {
    cat: "Los bomberos",
    items: [
      ["¿Los bomberos de Quilpué son voluntarios?",
        "Sí. El 100% de los bomberos de Chile son voluntarios — no cobran nada por su servicio."],
      ["¿Cuántas compañías tiene el Cuerpo de Bomberos de Quilpué?",
        "5 compañías más una brigada en formación. La escala mecánica prestará servicio desde el cuartel de la Segunda Compañía y atenderá a toda la provincia."],
      ["¿Cómo puedo contactar a los bomberos?",
        "Emergencias: 132 · Web: www.bomberosquilpue.cl · Campaña: donaciones@bomberosquilpue.cl"],
    ],
  },
  {
    cat: "Cómo ayudar más",
    items: [
      ["¿Cómo puedo ayudar además de donar?",
        "Comparte la campaña. Cada persona que se entera es un potencial donante. Usa el hashtag #MecanicaParaQuilpue en tus redes y suma a tu condominio, junta de vecinos o empresa."],
      ["¿Puedo ver quién ha donado?",
        "Sí. El portal muestra en tiempo real el feed de donaciones con nombres o anónimos según la elección de cada donante."],
      ["No encontré lo que buscaba.",
        "Escríbenos a donaciones@bomberosquilpue.cl o visita www.bomberosquilpue.cl. También puedes llamar al cuartel de la Segunda Compañía."],
    ],
  },
];

function FAQ({ bootstrap = null }) {
  const [faqData, setFaqData] = React.useState(FAQ_DATA_FALLBACK);
  const [activeCat, setActiveCat] = React.useState(0);
  const [openIdx, setOpenIdx] = React.useState(0);

  React.useEffect(() => {
    if (bootstrap === undefined) return; // esperando el fetch consolidado de App
    if (bootstrap) {
      if (bootstrap.faqs?.categories?.length) setFaqData(bootstrap.faqs.categories);
      return;
    }
    fetch("/api/faqs")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.categories?.length) setFaqData(data.categories);
      })
      .catch(() => {});
  }, [bootstrap]);

  function pickCat(i) {
    setActiveCat(i);
    setOpenIdx(0);
  }

  if (!faqData.length) return null;

  const items = faqData[activeCat]?.items || [];

  return (
    <section id="faq" style={{ borderTop: "1px solid var(--line)" }}>
      <div className="wrap">
        <div className="section-head fade-up">
          <h2 className="h-section">Preguntas <em>frecuentes</em></h2>
          <div className="eyebrow" style={{ marginTop: 16 }}>
            Antes de <em style={{ fontFamily: "var(--script)", textTransform: "none", letterSpacing: 0, fontStyle: "normal" }}>donar</em>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "260px 1fr", gap: 48, alignItems: "start" }} className="hero-grid">
          {/* Categorías */}
          <nav className="sticky-panel" style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {faqData.map((c, i) => (
              <button
                key={i}
                type="button"
                onClick={() => pickCat(i)}
                style={{
                  textAlign: "left",
                  padding: "12px 14px",
                  borderRadius: 8,
                  border: "1px solid",
                  borderColor: activeCat === i ? "var(--gold)" : "transparent",
                  background: activeCat === i ? "var(--accent-soft)" : "transparent",
                  color: activeCat === i ? "var(--fg)" : "var(--fg-mute)",
                  fontFamily: "var(--sans)",
                  fontSize: 13.5,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  transition: "color .15s, background-color .15s, border-color .15s",
                }}
              >
                <span>{c.cat}</span>
                <span style={{ color: "var(--fg-dim)", fontFamily: "var(--mono)", fontSize: 11 }}>
                  {String(c.items.length).padStart(2, "0")}
                </span>
              </button>
            ))}
          </nav>

          {/* Preguntas */}
          <div style={{ borderTop: "1px solid var(--line)" }}>
            {items.map((it, i) => (
              <FAQItem
                key={`${activeCat}-${i}`}
                q={it[0]}
                a={it[1]}
                open={openIdx === i}
                onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export { FAQ };
